import {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, F, FR, E} from "../_common/layout";
import {CompanyUser} from "../_api";
import {fetchUser} from "../_rx/_auth/actions";
import {Form as FinalForm} from "react-final-form";
import {FormField, SubmitButtonRow} from "../_common/forms/components/components";
import {saveUser} from "../_rx/jobs/actions";
import {Helmet} from "react-helmet";
import {USER_CHANGE_DATA_TITLE, USER_CHANGE_DATA_TITLE_PAGE} from "../constants";

type Props = {loggedUser:CompanyUser, fetchUser:Function, saveUser:Function, history:any};


class View extends Component<Props,{}> {

    componentDidMount() {
        this.props.fetchUser();
    }

    async onSubmit(user:CompanyUser){
        await this.props.saveUser(user)
        await this.props.fetchUser();
        this.props.history.push('/user');
    }

    render({ loggedUser, history }:Props) {

        if(!loggedUser) return null;

        return (
            <Fragment>
                <Helmet>
                        <title>{USER_CHANGE_DATA_TITLE_PAGE}</title>
                </Helmet>

                <FinalForm
                onSubmit={(data:CompanyUser)=>this.onSubmit(data)} initialValues={loggedUser}
                render={({handleSubmit,  submitting}:any)=>
                    <form className='form' action="" onSubmit={handleSubmit}  noValidate><F className='max-width'>
                        {loggedUser && <Fragment>
                            <C>
                                <FR>
                                    <E className="sm-col-40 col-100">
                                        <FormField label={'Nombre'} name="name" required />
                                    </E>
                                    <E className="sm-col-60 col-100">
                                        <FormField label={'Apellidos'} name="surname" required />
                                    </E>
                                </FR>
                                <FR>
                                    <div className="sm-col-40 col-100">
                                        <FormField label={'Teléfono'} name="phone" type="number" required />
                                    </div>
                                </FR>
                            </C>

                            <C>
                                <SubmitButtonRow disabled={submitting} onCancel={()=>history.push('/user')}/>
                            </C>
                        </Fragment>}
                    </F>
                    </form>}/>
            </Fragment>
        );
    }
}

const ConnectedView: any = connect(
    ({auth:{loggedUser}}:any)=>({loggedUser}), {fetchUser, saveUser})(View as any);

export default ({history}:any) =>
    <AppPage
        name="user-profile-edit"
        title={t(USER_CHANGE_DATA_TITLE)}
        subtitle=""
        className="max-width">
        <ConnectedView history={history} />

    </AppPage>
;
